export default {
      id: "time-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svgsprite.svg#time",
      toString: function () {
        return this.url;
      }
    }